import React from 'react';
import {usePreventDoubleClick} from '../components/hooks/usePreventDoubleClick';
import styles from './BotaoSalvar.module.css'; // opcional: estilize como quiser

function BotaoSalvar({ onClick, children = 'Salvar', className = '', ...props }) {
    const [handleClick, isSubmitting] = usePreventDoubleClick(onClick);

    return (
        <button
            type="submit"
            onClick={handleClick}
            disabled={isSubmitting}
            className={`${styles.botaoSalvar} ${className}`}
            {...props}
        >
            {isSubmitting ? 'Salvando...' : children}
        </button>
    );
}

export default BotaoSalvar;
